import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { GpsService } from '../../services/gps.service';
import { BackButtonComponent } from '../../components/back-button/back-button';

@Component({
    selector: 'app-gps-denegado',
    standalone: true,
    imports: [CommonModule, BackButtonComponent],
    templateUrl: './gps-denegado.html',
    styleUrls: ['./gps-denegado.scss']
})
export class GpsDenegadoComponent {
    private gpsService = inject(GpsService);
    private router = inject(Router);
    private route = inject(ActivatedRoute);

    errorMessage = signal(this.gpsService.getLocalizedErrorMessage());
    returnUrl = signal<string | null>(null);

    constructor() {
        this.route.queryParams.subscribe(params => {
            this.returnUrl.set(params['returnUrl'] || null);
        });
    }

    /**
     * Reintenta obtener la ubicación GPS.
     * Si tiene éxito, navega a la URL de retorno o al dashboard.
     */
    handleRetry(): void {
        this.gpsService.clearStoredCoordinates();

        this.gpsService.requestOrPromptManualEnable().then(result => {
            if (result.success) {
                const url = this.returnUrl() ?? '/dashboard';
                this.router.navigate([url]);
            } else if (result.needsManualEnable) {
                this.errorMessage.set(
                    'El permiso sigue denegado. Por favor, habilite la ubicación en la configuración de su navegador o dispositivo y luego reintente.'
                );
            } else {
                this.errorMessage.set(
                    'No se pudo obtener la ubicación. Verifique que el GPS esté activado.'
                );
            }
        }).catch(error => {
            console.error('[GpsDenegado] Error en reintento:', error);
            this.errorMessage.set('Error inesperado al intentar obtener la ubicación.');
        });
    }

    /**
     * Navega al dashboard sin GPS (solo para módulos que no lo requieren)
     */
    handleGoBack(): void {
        this.router.navigate(['/dashboard']);
    }
}
